import { render, staticRenderFns } from "./RecommendKeywordFooter.vue?vue&type=template&id=b738b44c"
import script from "./RecommendKeywordFooter.vue?vue&type=script&lang=js"
export * from "./RecommendKeywordFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports